<div class="grid">
    <div class="col-12 xs:col-12 md:col-5 lg:col-5 xl:col-5 m-auto mt-6">
        <router-outlet />
    </div>
</div>
